import useRootData from "~/hooks/useRootData";

export type SpecialPageKey = "projectsPage" | "mediaPage" | "calendarPage";

export default function useSpecialPageUrl(key: SpecialPageKey) {
	return useRootData()?.data.specialPages[key];
}
